// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import globalReducer from '../features/global/globalSlice'
// import authReducer ...

export const store = configureStore({
  reducer: {
    // auth: authReducer,
    global: globalReducer, // <--- Thêm dòng này
  },
});